import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { set } from 'lodash-es';
import { AUTH_TOKEN_SKIP, AUTH_TOKEN_SKIP_REFRESH } from '../../../shared/consts/http.const';
import { IAuthLogin } from '../../../shared/types/auth.type';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);

  private skipAuthToken: HttpHeaders;
  private skipRefreshToken: HttpHeaders;

  constructor() {
    this.skipAuthToken = new HttpHeaders(set({}, AUTH_TOKEN_SKIP, 1));
    this.skipRefreshToken = new HttpHeaders(set({}, AUTH_TOKEN_SKIP_REFRESH, 1));
  }

  /**
   * Аутентификация
   */
  login(username: string, password: string) {
    return this.http.post<IAuthLogin>(
      '/auth/sign-in/basic',
      { username, password },
      {
        headers: this.skipAuthToken,
      },
    );
  }

  /**
   * Аутентификация альтернативным способом
   */
  loginExternal(type: string, index: number, data: { [key: string]: unknown }) {
    return this.http.post<IAuthLogin>(
      '/auth/sign-in/external',
      { type, index, data },
      {
        headers: this.skipAuthToken,
      },
    );
  }

  /**
   * Обновление access token
   * @param refreshToken
   */
  refreshToken(refreshToken: string) {
    return this.http.post<IAuthLogin>(
      '/auth/session/refresh',
      { refreshToken },
      {
        headers: this.skipAuthToken,
      },
    );
  }

  /**
   * Выход, удаление сессии
   */
  logout() {
    return this.http.post<IAuthLogin>(
      '/auth/session/close',
      {},
      {
        headers: this.skipRefreshToken,
      },
    );
  }
}
